import { Box, CircularProgress } from "@mui/material";

export const LoadingIcon = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingIcon;
